module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "size": "confirm_size",
      "title": "Start Discussion"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col h-full py-4 px-6"
  }, [_c('div', {
    staticClass: "flex flex-grow h-full mb-5"
  }, [_c('div', {
    staticClass: "text-gray-700"
  }, [_vm._v("\n        Starting the discussion will "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("allow students")]), _vm._v(" to begin tapping in to\n        speak. Engagement "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("statistics will be tracked until")]), _vm._v(" the discussion is\n        stopped. You can "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("start and stop")]), _vm._v(" the\n        discussion at any time!\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between space-x-4"
  }, [_c('button', {
    staticClass: "w-full bg-gray-100 border border-solid border-gray-200 rounded-md py-2 px-4 text-gray-700",
    on: {
      "click": function($event) {
        _vm.show_start_discussion = false
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "flex justify-center items-center space-x-2 w-full bg-green rounded-md border border-solid border-green-600 py-2 px-4 text-white",
    on: {
      "click": function($event) {
        return _vm.handleStartDiscussion()
      }
    }
  }, [_c('span', [_vm._v("Start Discussion")]), _vm._v(" "), (_vm.isStarting) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a82b8622!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/Modals/MDStartDiscussion.vue
// module id = 1856
// module chunks = 61